export default "/fonts/Flaticon.svg?9b97d4a03f52096e0278a9fe29e338ae";